export default __webpack_public_path__ + "static/media/asset-4.80451d46.svg";